import { render, staticRenderFns } from "./BookableSchedules.vue?vue&type=template&id=328fef9b&scoped=true"
import script from "./BookableSchedules.vue?vue&type=script&lang=js"
export * from "./BookableSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328fef9b",
  null
  
)

export default component.exports